import React from 'react';
import { Routes, Route } from "react-router-dom";
import NavBrandBackend from './../../theme/layout_backend2'
import PMIS from '../../components/pmis/MainRoute'
import ShiftManagement from '../shift_management/Main_route'
import InventoryCheck from '../inventory_check/MainRoute'
import QueueManagement from './queue_management'
import AreaManagement from './views/area_management'
import { Mainlayout } from '../ui/ot';
import SOPDisplay from '../ai_flow_automation/views/sop_display';
import SOPDisplaySelf from '../ai_flow_automation/views/sop_display_self';
import NaturePersonManagement from './views/nature_person_management';

const MainRoute = ({
    menuData = []
}) => {

    return (
        <Routes>
            <Route path={'/'}
            // element={<NavBrandBackend logo="OT" footer={"Orange Technic"} not_sider menuData={menuData} />}
            >
                <Route path={''} element={<Mainlayout />}>
                    <Route path={"/shift_management/*"} element={<ShiftManagement />} />
                    <Route path={'/inventory_check/*'} element={<InventoryCheck />} />
                    <Route path={'/pmis/*'} element={<PMIS />}></Route>
                    <Route path={'/sop_display'} element={<SOPDisplay keyPrefix='queue_management.sop_display' />}></Route>
                    <Route path={'/sop_display_self'} element={<SOPDisplaySelf keyPrefix='queue_management.sop_display_self' />}></Route>
                    <Route path={'/queue_management'} element={<QueueManagement mode={'admin'} key={'queue_management'} />}></Route>
                    <Route path={'/queue_management_self'} element={<QueueManagement mode={'admin'} key={'queue_management_self'} self={true} propsExport={false} propsPost={false} showMode={'card'}/>}></Route>
                    <Route path={'/area_management'} element={<AreaManagement key={'area_management'} admin={true} />}></Route>
                </Route>

                <Route path="" element={<Mainlayout />}>
                    <Route path={'sop_display'} element={
                        <SOPDisplay self={false} />
                    } />
                    <Route path={'staff'} element={<NaturePersonManagement mode={'admin'} key={'admin'} />}>
                    </Route>
                    <Route path={'nature_person'} element={<NaturePersonManagement mode={'admin'} key={'admin'} />}>
                    </Route>
                </Route>
            </Route>
        </Routes>
    );
}
export default MainRoute;
